import React from 'react';
import {
    Button, Spinner,
} from 'reactstrap';
import { isNil } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { getShortUTC } from '@s20/common/util/date';
import { Can } from '../Can';
import { SmallButton } from '../common/forms/FormElements';
import CommonContext from '../Common';
import { PriceDisplay } from '../common/PriceDisplay';
import { BillingRateTypes } from './BillingRate';

export class BillingRateGrid extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            showForm: false,
        };
    }

    componentDidMount() {
        this.populateState();
    }

    populateState() {
        this.setState({
            loading: false,
        });
    }

    render() {
        const { tenantSettings } = (this.context ?? {}).tenant ?? {};

        if (!tenantSettings.billingRatesEnabled) {
            return '';
        }

        const { loading } = this.state;

        if (loading) {
            return (
                <Spinner />
            );
        }

        const {
            rates, showDoubleTime, showShiftDifferential, overtimeEnabled = true,
            rateType = BillingRateTypes.CHARGE_TYPE,
        } = this.props;

        const doubleTimeEnabled = showDoubleTime && !!tenantSettings.enableDoubleTimeBilling;
        const shiftDifferentialEnabled = showShiftDifferential && !!tenantSettings.enableShiftDifferentialBilling;

        const isChargeTypeGroup = rateType === BillingRateTypes.CHARGE_TYPE_GROUP;

        return (
            <>
                <div className="d-flex flex-row align-items-center justify-content-end">
                    <Can
                        I="edit"
                        a="chargetype"
                    >
                        <CommonContext.Consumer>
                            {(value) => (
                                <SmallButton
                                    type="button"
                                    disabled={!!value.formIsOpen}
                                    onClick={this.props.onAddRate}
                                >
                                    <i className="fa fa-plus-circle fa-md mr-2" />
                                    Add Rate
                                </SmallButton>
                            )}
                        </CommonContext.Consumer>
                    </Can>
                </div>

                <table className="table table-sm table-bordered background-white">
                    <thead>
                        <tr>
                            {Boolean(this.props.showChargeType) && (
                                <th style={{ width: doubleTimeEnabled || isChargeTypeGroup ? '15%' : '30%' }}>
                                    {isChargeTypeGroup ? 'Description' : 'Charge Type'}
                                </th>
                            )}

                            {Boolean(isChargeTypeGroup) && (
                                <th style={{ width: '15%' }}>
                                    Charge Type(s)
                                </th>
                            )}

                            <th style={{ width: '15%' }}>Rate</th>

                            {Boolean(shiftDifferentialEnabled) && (
                                <th style={{ width: '15%' }}>
                                    RSD Rate
                                </th>
                            )}

                            {Boolean(overtimeEnabled) && (
                                <th style={{ width: '15%' }}>
                                    Overtime Rate
                                </th>
                            )}

                            {Boolean(doubleTimeEnabled) && (
                                <th style={{ width: '15%' }}>
                                    DT Rate
                                </th>
                            )}
                            <th style={{ width: '20%' }}>
                                Effective Date
                            </th>
                            <th style={{ width: '20%' }}>
                                Expiration Date
                            </th>
                            <th style={{ width: '5%' }}>Active</th>
                            {/* <th style={{ width: '5%' }}>History</th> */}
                            <Can
                                I="edit"
                                a="chargetype"
                            >
                                <th
                                    className="text-center"
                                    style={{ width: '5%' }}
                                >
                                    <FontAwesomeIcon icon={faEdit} />
                                </th>
                            </Can>
                        </tr>
                    </thead>
                    <tbody>
                        {!(rates ?? []).length ? (
                            <tr>
                                <td
                                    colSpan="9"
                                    className="text-center"
                                >
                                    No rates found.
                                </td>
                            </tr>
                        ) : (
                            this.props.rates.map((rate) => (
                                <tr key={rate.billingRateId}>
                                    {(this.props.showChargeType ?? {}) == true && (
                                        <td>
                                            {rate.chargeTypeName ?? rate.chargeTypeGroupName}
                                        </td>
                                    )}

                                    {Boolean(isChargeTypeGroup) && (
                                        <td>
                                            {rate.chargeTypes}
                                        </td>
                                    )}

                                    <td>
                                        {!isNil(rate.billingRate.rate)
                                            && <PriceDisplay amount={rate.billingRate.rate} />
                                        }
                                    </td>

                                    {Boolean(shiftDifferentialEnabled) && (
                                        <td>
                                            {!isNil(rate.billingRate.sdRate) && (
                                                <PriceDisplay amount={rate.billingRate.sdRate} />
                                            )}
                                        </td>
                                    )}

                                    {Boolean(overtimeEnabled) && (
                                        <td>
                                            {!isNil(rate.billingRate.otRate)
                                                && <PriceDisplay amount={rate.billingRate.otRate} />
                                            }
                                        </td>
                                    )}

                                    {Boolean(doubleTimeEnabled) && (
                                        <td>
                                            {!isNil(rate.billingRate.altRate) && (
                                                <PriceDisplay amount={rate.billingRate.altRate} />
                                            )}
                                        </td>
                                    )}

                                    <td>
                                        {!isNil(
                                            rate.billingRate
                                                .effectiveDate,
                                        )
                                            && getShortUTC(
                                                rate.billingRate
                                                    .effectiveDate,
                                            )}
                                    </td>
                                    <td>
                                        {!isNil(
                                            rate.billingRate
                                                .expirationDate,
                                        )
                                            && getShortUTC(
                                                rate.billingRate
                                                    .expirationDate,
                                            )}
                                    </td>
                                    <td>
                                        {rate.billingRate.current
                                            ? 'Active'
                                            : 'Inactive'}
                                    </td>
                                    {/* <td> */}
                                    {/*    <SmallButton */}
                                    {/*        type="button" */}
                                    {/*        onClick={() => this.props.onShowRateHistory(rate)} */}
                                    {/*    > */}
                                    {/*        <i className="fa fa-history fa-md" /> */}
                                    {/*    </SmallButton> */}
                                    {/* </td> */}
                                    <Can
                                        I="edit"
                                        a="chargetype"
                                    >
                                        <td
                                            className="text-center"
                                            style={{
                                                width: '30px',
                                            }}
                                        >
                                            <CommonContext.Consumer>
                                                {(value) => (
                                                    <Button
                                                        disabled={
                                                            !!value.formIsOpen
                                                        }
                                                        type="button"
                                                        color="outline-primary"
                                                        onClick={() => this.props.onEditRate(
                                                            rate,
                                                        )}
                                                        size="sm"
                                                    >
                                                        Edit
                                                    </Button>
                                                )}
                                            </CommonContext.Consumer>
                                        </td>
                                    </Can>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </>
        );
    }
}
